import React from "react";
import { Link } from "react-router-dom";

export default function PaymentFailure() {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      {/* Error Icon */}
      <div className="bg-[#FFE9E9] p-14 w-fit rounded-full mb-6">
        <div className="bg-[#FDCBCB] p-6 w-fit rounded-full">
          <div className="bg-[#CC1B10] p-4 w-fit rounded-full">
            <svg
              className="size-8 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Message */}
      <h1 className="text-3xl font-bold text-[#CC1B10] mb-4">Payment Failed</h1>
      <p className="text-gray-600 max-w-md mb-8">
        Something went wrong while processing your payment. Please try again or
        use a different payment method.
      </p>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/checkout">
          <button
            className="bg-[image:--gradient] font-semibold text-white px-8 py-3 rounded-lg hover:opacity-80"
            style={{
              "--gradient": "linear-gradient(90deg, #990900 0%, #CC1B10 100%)",
              boxShadow: "0px 4px 29.2px 7px #00000040",
            }}
          >
            Try Again
          </button>
        </Link>

        <Link to="/">
          <button className="border-2 border-[#CC1B10] text-[#CC1B10] px-8 py-3 rounded-lg hover:bg-[#FFE9E9] transition">
            Back to Home
          </button>
        </Link>
      </div>
    </div>
  );
}
